module.exports = __webpack_public_path__ + "img/ulrike_lentzsch.1a570a1f.jpg";